import styled from 'styled-components/macro'

import Typography from '@material-ui/core/Typography'

const H2 = styled(Typography)`
  font-size: 1.4rem;
`

export default H2
